import './index.css'
import translate from '@/utils/translate';
import _ from 'lodash'
export default {
    props: ['list'],
    data() {
        return {
            select: []
        }
    },
    methods: {
        toggle(id) {
            if (this.select.includes(id)) {
                this.select = _.without(this.select, id)
            } else {
                this.select.push(id)
            }
        }
    },
    render() {
        return (
            <div class="select-box">
                <div class="select-box-content">
                    {this.list.map(it => (
                        <div class="select-item" onClick={() => this.toggle(it.id)}>
                            <i class="check-box" class={["check-box", this.select.includes(it.id) && "checked"]}></i>
                            <span>{it.title}</span>
                        </div>
                    ))}
                </div>
                <div class="buttons">
                    <button onClick={()=>this.$emit('select',this.select)}>{translate("Apply")}</button>
                    <button onClick={()=>this.$emit('cancel')} class="ghost">{translate("Cancel")}</button>
                </div>
            </div>
        )
    }
}